// React
import React from 'react';
// Material-UI
import { Typography } from '@material-ui/core';
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * 
 * @typedef {Object} Props
 * @property {string} titulo Título de contenedor
 * @property {string} subtitulo Subtitulo de contenedor
 */

/**
 * Sección
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const TituloContenedor = ({
    titulo = '',
    subtitulo = '',
}) => {
    // Idioma
    
    // Token
    
    // Estados

    // Listas
    
    // Funciones

    // Vista
    return (
        <div>
            <div>
                <Typography variant="h6" gutterBottom>
                    {titulo}
                </Typography>
            </div>
            {subtitulo !== '' && (
                <div>
                    <Typography variant="body1" gutterBottom>
                        {subtitulo}
                    </Typography>
                </div>
            )}
        </div>
    );
};
